export enum HeaderThemes {
    DEFAULT = 'default',
    TRANSPARENT = 'transparent'
}
